import React, { useRef, useEffect, useState } from "react";
import menuClasses from "./topProfile.module.scss";
import Profilepic from "Assets/profile.svg";
import { FaUser } from "react-icons/fa";
import { FaUserGraduate } from "react-icons/fa";
import { RiMessage2Fill } from "react-icons/ri";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { MdOutlinePrivacyTip } from "react-icons/md";
import { useCookies } from "react-cookie";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import useStore from "store";
import { Get_Kid_Details } from "Service/parent";
import { profileData } from "../../../../Pages/Parent/Profile/types";
import { warningSwal, SuccessSwal } from "Reusable/utils/Toast";
import StudentProfileModal from "../../../../Pages/Parent/Profile/profileDetails/profile";

type props = {
    setIsProfileVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setTab: React.Dispatch<React.SetStateAction<string>>;
    setAddKitModal: React.Dispatch<React.SetStateAction<boolean>>;
    setParentProfileModal: React.Dispatch<React.SetStateAction<boolean>>;
    setshowComplaint: React.Dispatch<React.SetStateAction<boolean>>;
    setShowConsent: React.Dispatch<React.SetStateAction<boolean>>;
};
const TopProfile: React.FC<props> = ({
    setIsProfileVisible,
    setAddKitModal,
    setParentProfileModal,
    setTab,
    setshowComplaint,
    setShowConsent,
}) => {
    const Navigate = useNavigate();
    const [profileData, setProfileData] = useState<profileData>();
    const [profileModal, setProfileModal] = useState(false);
    const popupRef = useRef<HTMLDivElement>(null);
    const { setDemoForm } = useStore((item: any) => item);
    const [cookie, _, removeCookie] = useCookies([
        "parentDetails",
        "StudentDetails",
        "HomepageCourses",
        "HomepageData",
        "currentStudent",
    ]);
    useEffect(() => {
        // Add event listener when the component mounts
        document.addEventListener("mousedown", handleOutsideClick);
        const fetchProfileData = async () => {
            const token = {
                Authorization: `token ${localStorage.getItem(
                    "learn2readToken"
                )}`,
            };
            try {
                const [profileData] = await Promise.all([
                    Get_Kid_Details(
                        "GET",
                        null,
                        token,
                        localStorage.getItem("student")
                    ),
                ]);
                if (profileData?.Status === 1) {
                    setProfileData(profileData.Students);
                }
            } catch {
                warningSwal("Warning", "something Went wrong try again");
            }
        };
        if (localStorage.getItem("student")) {
            fetchProfileData();
        }
        // Remove event listener when the component unmounts
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleOutsideClick = (event: MouseEvent) => {
        // Close the popup if the click is outside of it
        if (
            popupRef.current &&
            !popupRef.current.contains(event.target as Node)
        ) {
            setIsProfileVisible(false);
        }
    };
    const logoutHandler = () => {
        Swal.fire({
            title: "Are you sure you want to logout",
            showDenyButton: true,
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "Yes",
            denyButtonText: "No",
            customClass: {
                actions: menuClasses["popup-actions"],
                cancelButton: "order-1 right-gap",
                confirmButton: menuClasses["logout-popup"],
                denyButton: "order-3",
            },
        }).then((result: any) => {
            if (result.isConfirmed) {
                localStorage.clear();
                sessionStorage.clear();
                Navigate("/");
                setTab("HOME");
                removeCookie("currentStudent");
                removeCookie("HomepageData");
                removeCookie("StudentDetails");
                removeCookie("parentDetails");
                removeCookie("HomepageCourses");
            }
        });
    };
    return (
        <>
            {profileModal && (
                <StudentProfileModal
                    setModal={setProfileModal}
                    showModal={profileModal}
                    Data={profileData}
                    setProfileData={setProfileData}
                    EditMode={true}
                />
            )}
            <div className={menuClasses["TopNav_Container"]} ref={popupRef}>
                <div className={menuClasses["header"]}>
                    <img src={Profilepic} alt="profile" />
                    <h3>
                        {cookie?.parentDetails?.FirstName
                            ? String(cookie?.parentDetails.FirstName).slice(
                                  0,
                                  15
                              )
                            : "User"}{" "}
                        {cookie?.parentDetails?.LastName &&
                        cookie?.parentDetails?.LastName != "NA"
                            ? String(cookie?.parentDetails.LastName).slice(
                                  0,
                                  15
                              )
                            : ""}
                    </h3>
                </div>
                <ul>
                    <li onClick={() => setParentProfileModal(true)}>
                        <button>
                            <FaUser /> Update Parent Profile
                        </button>
                    </li>
                    <li onClick={() => setProfileModal(true)}>
                        <button>
                            <FaUser /> Update Student Profile
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => {
                                setAddKitModal(true);
                            }}>
                            <FaUserGraduate />
                            Add Kid
                        </button>
                    </li>
                    {/* <li>
                        <button>
                            <FaWallet />
                            My Wallet
                        </button>
                    </li> */}

                    <li>
                        <button
                            onClick={() => {
                                setDemoForm(true);
                            }}>
                            {" "}
                            <TfiHeadphoneAlt />
                            Request Demo
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => {
                                setshowComplaint(true);
                            }}>
                            <RiMessage2Fill />
                            Raise Complaint
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => {
                                setShowConsent(true);
                                setIsProfileVisible(false);
                            }}>
                            <MdOutlinePrivacyTip />
                            Manage Consent
                        </button>
                    </li>
                </ul>
                <button onClick={logoutHandler}>Sign Out</button>
            </div>
        </>
    );
};

export default TopProfile;
